import React, { useRef } from "react";
import { Badge } from "@mui/material";
import {
  ArrowDropDown,
  Search,
  ShoppingCartOutlined,
  List,
} from "@mui/icons-material";
import styled from "styled-components";
import { mobile } from "../responses";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  quantitySelector,
  productsSelector,
  totalpriceSelector,
  addProduct,
  logoutProduct,
} from "../redux/cartRedux";
import { currentUserSelector, logOutSuccess } from "../redux/userRedux";
import { toast } from "react-hot-toast";

const Container = styled.div`
  height: 60px;
  ${mobile({ height: "50px" })}
`;
const Wrapper = styled.div`
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${mobile({ padding: "15px 0px", height: "2vh" })}
`;

const Left = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;
const SearchContainer = styled.div`
  border: 1px solid lightgray;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin-left: 1rem;
  padding: 0.2rem;
`;
const Language = styled.span`
  font-size: 14px;
  cursor: pointer;
  ${mobile({ display: "none" })}
`;

const Input = styled.input`
  outline: none;
  border: none;
  ${mobile({ width: "50px" })}
`;

const Center = styled.div`
  flex: 1;
  text-align: center;
  ${mobile({ flex: "5" })}
`;
const Logo = styled.h1`
  font-weight: bold;
  margin-block: 0rem;
  ${mobile({ fontSize: "24px" })}
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  ${mobile({ flex: 2, justifyContent: "center", position: "relative" })}
`;

const Expand = styled.div`
  display: flex;
  align-items: center;
  ${mobile({ display: "none" })}
`;
const Menu = styled.div`
  font-size: 14px;
  cursor: pointer;
  margin-inline: 1rem;
  ${mobile({
    backgroundColor: "white",
    width: "100%",
    height: "100%",
    textAlign: "center",
  })};
  transition: all 0.5s ease;

  &:hover {
    background-color: #d7cfcf;
  }
`;

const DropDown = styled.div`
  display: none;
  ${mobile({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    position: "absolute",
    top: "30px",
    right: "5px",
    height: "0vh",
    overflowY: "auto",
    overflowX: "hidden",
    zIndex:"222"
  })}
  transition: all .3s ease;
`;
const DropDownIcon = styled.div`
  display: none;
  ${mobile({ display: "block", margin: "2px 0" })}
`;

const Navbar = () => {
  const activity = useSelector(currentUserSelector);
  // console.log({ activity });
  const { toBeSent } = activity || { toBeSent: "" };

  const DropDownIconRef = useRef();
  const DropDownExpandRef = useRef();

  const changeIcon = (e) => {
    console.log(
      e.target,
      DropDownIconRef,
      DropDownExpandRef.current.type,
      DropDownExpandRef.current.style.height
    );
    if (DropDownExpandRef.current.style.height !== "100px") {
      DropDownExpandRef.current.style.height = "100px";
    } else {
      DropDownExpandRef.current.style.height = "0px";
    }
  };

  const dispatch = useDispatch();
  const quantity = useSelector(quantitySelector);
  // console.log({ quantity });

  const handleLogOut = () => {
    dispatch(logOutSuccess());
    dispatch(logoutProduct());
    toast.success("Logged Out SuccessFully!")
  };


  return (
    <Container>
      <Wrapper>
        <Left>
          <Language>EN</Language>
          <SearchContainer>
            <Input placeholder="Search" />
            <Search style={{ color: "gray", fontSize: "1rem" }} />
          </SearchContainer>
        </Left>

        <Center>
          <Logo>
            <Link to={"/"}>Vivegam</Link>
          </Logo>
        </Center>

        <Right>
          <Expand>
            <Menu>
              {activity?.message !== "success" ? (
                <Link to={"/register"}>REGISTER</Link>
              ) : (
                <Link to={"/user"}>
                  {toBeSent.firstName || toBeSent.username}
                </Link>
              )}
            </Menu>

            <Menu>
              {activity?.message !== "success" ? (
                <Link to={"/login"}>SIGN IN</Link>
              ) : (
                <Link to={"/login"} onClick={handleLogOut}>
                  LogOut
                </Link>
              )}
            </Menu>

            <Link to={"/cart"}>
              <Menu>
                <Badge badgeContent={quantity} color="primary">
                  <ShoppingCartOutlined />
                </Badge>
              </Menu>
            </Link>
          </Expand>


          <DropDownIcon onClick={changeIcon} ref={DropDownIconRef}>
            <List />
          </DropDownIcon>

          <DropDown ref={DropDownExpandRef} type="open">
            <Menu>
            {activity?.message !== "success" ? (
                <Link to={"/register"}>REGISTER</Link>
              ) : (
                <Link to={"/user"}>
                  {toBeSent.firstName || toBeSent.username}
                </Link>
              )}
            </Menu>
            <Menu>
            {activity?.message !== "success" ? (
                <Link to={"/login"}>SIGN IN</Link>
              ) : (
                <Link to={"/login"} onClick={handleLogOut}>
                  LogOut
                </Link>
              )}
            </Menu>

            <Link to={"/cart"}>
              <Menu >
                <Badge badgeContent={quantity} color="primary">
                  <ShoppingCartOutlined />
                </Badge>
              </Menu>
            </Link>

          </DropDown>



        </Right>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
